import { Observable } from 'rxjs/Observable'
import { InputValidationObserver } from './input-validation.observer'

export class InputValidationComponent {

  constructor(formElement, constraints) {
    this.constraints = constraints
    this.formElement = formElement
    this.element = (formElement) ? formElement.querySelectorAll("input, select, textarea") : undefined
    this.inputChangeStream = Observable.fromEvent(this.element, 'change')
  }

  init() {
    if(this.element) {
      this.inputChangeStream
          .pluck('target')
          .subscribe(new InputValidationObserver(this.formElement, this.constraints))
    }
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/validation/input/input-validation.component.js